import { useChatContext } from '../context/ChatContext';

/**
 * Custom hook that provides read-only access to chat state
 */
export const useChatState = () => {
  const { state } = useChatContext();
  return state;
};